module.exports = __webpack_public_path__ + "img/t2_wing_nuts.prt.a82fd0fd.jpg";